import script from "./FamilyRides.vue?vue&type=script&setup=true&lang=js"
export * from "./FamilyRides.vue?vue&type=script&setup=true&lang=js"

import "./FamilyRides.vue?vue&type=style&index=0&id=ab207022&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab207022"]])

export default __exports__